import { useState, useEffect } from 'react';
import futbolistaService from '../services/futbolistaService';

/**
 * Componente que muestra el horario de partido para un futbolista en una jornada específica
 * @param {Object} props
 * @param {number} props.futbolistaId - ID del futbolista
 * @param {number} props.jornadaId - ID de la jornada
 * @param {string} props.className - Clases CSS adicionales
 */
const HorarioPartido = ({ futbolistaId, jornadaId, className = '' }) => {
  const [horario, setHorario] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHorario = async () => {
      if (!futbolistaId || !jornadaId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);
        
        const response = await futbolistaService.getFutbolistaHorarioJornada(futbolistaId, jornadaId);
        
        if (response.success && response.data) {
          setHorario(response.data);
        } else {
          // No hay horario asignado (futbolista no está en ningún partido)
          setHorario(null);
        }
      } catch (err) {
        console.error('Error al obtener horario del futbolista:', err);
        setError('Error al cargar horario');
      } finally {
        setLoading(false);
      }
    };

    fetchHorario();
  }, [futbolistaId, jornadaId]);

  // Formatear hora para mostrar
  const formatearHora = (hora) => {
    if (!hora) return '';
    
    // Si la hora viene en formato HH:MM:SS, extraer solo HH:MM
    if (typeof hora === 'string' && hora.includes(':')) {
      const partes = hora.split(':');
      return `${partes[0]}:${partes[1]}`;
    }
    
    return hora;
  };

  if (loading) {
    return (
      <span className={`horario-partido loading ${className}`}>
        ⏳ Cargando...
      </span>
    );
  }

  if (error) {
    return (
      <span className={`horario-partido sin-horario ${className}`}>
        ⏰ Sin horario asignado
      </span>
    );
  }

  if (!horario) {
    // No hay horario asignado - el futbolista no está asignado a ningún partido
    return (
      <span className={`horario-partido sin-horario ${className}`}>
        ⏰ Sin horario asignado
      </span>
    );
  }

  return (
    <span className={`horario-partido ${className}`}>
      🕐 {formatearHora(horario.hora)} - Equipo {horario.equipo_numero}
      {/* C-01 multi-campo: mostrar instalación si el partido tiene campo asignado */}
      {horario.campo_nombre && (
        <span
          className="horario-campo"
          title={horario.campo_direccion || ''}
          style={{ marginLeft: '8px', fontSize: '0.9em', color: '#0d6efd', whiteSpace: 'nowrap' }}
        >
          📍 {horario.campo_nombre}
        </span>
      )}
    </span>
  );
};

export default HorarioPartido;
